import React from 'react';
import TextRephraseIcon from '@bufferapp/ui/Icon/Icons/TextRephrase';
import TextSummarizeIcon from '@bufferapp/ui/Icon/Icons/TextSummarize';
import TextExpandIcon from '@bufferapp/ui/Icon/Icons/TextExpand';
import MagicWandIcon from '@bufferapp/ui/Icon/Icons/MagicWand';

export const ACTIONS = {
  generateText: {
    id: 'generateText',
    label: 'Generate',
    loadingLabel: 'Generating',
    icon: <MagicWandIcon />,
  },
  rephraseText: {
    id: 'rephraseText',
    label: 'Rephrase',
    loadingLabel: 'Rephrasing',
    icon: <TextRephraseIcon />,
  },
  summarizeText: {
    id: 'summarizeText',
    label: 'Summarize',
    loadingLabel: 'Summarizing',
    icon: <TextSummarizeIcon />,
  },
  expandText: {
    id: 'expandText',
    label: 'Expand',
    loadingLabel: 'Expanding',
    icon: <TextExpandIcon />,
  },
};

export const PROMPT_MIN_WORDS_LIMIT = 4;
export const PROMPT_MAX_LENGTH_LIMIT = 10000;

export const URL_LEARN_MORE =
  'https://support.buffer.com/hc/en-us/articles/13802679839635-Using-Buffer-s-AI-Assistant#h_01GS8G1RP30E19WYDGFG2SGHVT';
